export default __webpack_public_path__ + "static/dt-product-c0ef74b2998f99e53f82b264ad502963.png";